export default class User {
  constructor(tenant, role, id, name, password) {
    this.tenant = tenant;
    this.role = role;
    this.id = id;
    this.name = name;
    this.password = password;
  }
}
